import { useState, useEffect } from 'react';
import { signInWithGoogle } from '../services/authService';
import { APP_NAME } from '../utils/constants';
import { toast } from 'react-toastify';
import LoadingSpinner from '../components/common/LoadingSpinner';

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Log that we're on the login page for debugging
  useEffect(() => {
    console.log('Login page loaded. Ready for authentication test.');
    console.log('This app connects to the real Firebase project: algobridge-36446');
  }, []);

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError(null);

    console.log('Initiating Google Sign-in process...');
    try {
      const { user, claims } = await signInWithGoogle();

      // Log successful authentication details
      console.log('Authentication successful!');
      console.log('User:', {
        uid: user.uid,
        email: user.email,
        displayName: user.displayName,
        emailVerified: user.emailVerified,
      });

      // Check for role in claims
      const role = claims?.role;
      if (!role) {
        console.warn('No role found in claims!');
        toast.warning('Your account has no role assigned in custom claims.');
      } else {
        console.log(`User role from claims: ${role}`);
      }

      // Auth state change will trigger navigation automatically
    } catch (error) {
      console.error('Login error:', error);
      setError(`Failed to sign in: ${error.message || 'Unknown error'}`);
      toast.error('Authentication failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="max-w-md w-full p-6 bg-white rounded-lg shadow-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">{APP_NAME}</h1>
          <p className="text-gray-600">
            Sign in with your Google account to access the Signal Bridge dashboard.
          </p>
        </div>

        {error && <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md">{error}</div>}

        <button
          onClick={handleGoogleSignIn}
          disabled={loading}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md flex items-center justify-center"
        >
          {loading ? (
            <div className="flex items-center">
              <LoadingSpinner size={8} color="#ffffff" text="" />
              <span className="ml-2">Signing in...</span>
            </div>
          ) : (
            <>
              <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="currentColor"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="currentColor"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="currentColor"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>
              Sign in with Google
            </>
          )}
        </button>

        {/* REGISTER NOW BUTTON */}
        <button
          onClick={() => {
            // TODO: Implement register functionality
            console.log('Register clicked');
          }}
          disabled={loading}
          className="w-full bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-md flex items-center justify-center mt-2"
        >
          Register Now
        </button>

        <div className="mt-4 text-center text-sm text-gray-500">
          <p>
            New user? Click Register to request access, or contact your administrator for your
            login details.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
